import { useLayers } from './LayerProvider';
import { LayerSurface } from './LayerSurface';
import type { LayerDelivery } from './types';

/**
 * Hostitel vrstev vykreslovaných mimo tok stránky.
 *
 *   • `region="announcement"` — oznamovací lišta V TOKU dokumentu (nad
 *     hlavičkou); nezpůsobuje CLS skok.
 *   • `region="overlay"` — pop-up (jeden na page-view) a plovoucí widgety.
 *
 * Sloty `banner`/`inline`/`recommendation` NEjdou přes hosta — ty vykresluje
 * `<LayerSlot>` do pojmenovaných míst ve stránce.
 */
export function LayerHost({ region }: { region: 'overlay' | 'announcement' }) {
  const { popup, hostWeblayers, close, interact, submitted } = useLayers();

  const handlers = (layer: LayerDelivery) => ({
    onClose: () => close(layer),
    onInteract: (kind: 'click' | 'submit') => interact(layer, kind),
    onSubmitted: () => submitted(layer),
  });

  if (region === 'announcement') {
    const announcements = hostWeblayers.filter((layer) => layer.kind === 'announcement');
    if (announcements.length === 0) return null;
    return (
      <>
        {announcements.map((layer) => (
          <LayerSurface key={layer.id} layer={layer} {...handlers(layer)} />
        ))}
      </>
    );
  }

  // overlay: pop-up + plovoucí widgety
  const floating = hostWeblayers.filter((layer) => layer.kind === 'floating_widget');
  return (
    <>
      {popup !== null && <LayerSurface key={popup.id} layer={popup} {...handlers(popup)} />}
      {floating.map((layer) => (
        <LayerSurface key={layer.id} layer={layer} {...handlers(layer)} />
      ))}
    </>
  );
}
